/**
 * @packageDocumentation
 * Builds the info button control and its popup, giving players access to help and game details at runtime.
 */
import * as PIXI from "pixi.js";
import { Assets } from "pixi.js";
import { brightnessFilter, font_main } from "./global";
import { SoundManager } from "./sounds";

/**
 * Class representing the Info area UI component
 * @extends PIXI.Container
 */
export class InfoButton extends PIXI.Container {
  private InfoContainer: PIXI.Container;
  // private PopupContainer: PIXI.Container | null = null;

  constructor() {
    super();

    // Main container for the button
    this.InfoContainer = new PIXI.Container();

    // Info Button Background
    const InfoBg: PIXI.Sprite = new PIXI.Sprite(Assets.get("BTN_how2Play"));
    InfoBg.anchor.set(0.5);
    InfoBg.scale.set(0.75);

    // Note: Text removed since new asset BTN_how2Play.png has text built-in

    this.InfoContainer.addChild(InfoBg);

    // Make the button interactive
    this.InfoContainer.interactive = true;
    // this.InfoContainer.buttonMode = true;
    this.InfoContainer.on("pointertap", () => {
      // this.showPopup();
      SoundManager.Btnclick_1SndPlay();
      document.getElementById('info-page')!.style.display = 'block';
    });
    this.InfoContainer.cursor = "pointer"
    // this.InfoContainer.on("pointerdown", () => this.closePopup());
      // this.InfoContainer.on("pointertap", () => this.closePopup()); 
      this.InfoContainer.on("pointerover",()=>{
        this.InfoContainer.filters = [brightnessFilter]
      })
      this.InfoContainer.on("pointerout",()=>{
        this.InfoContainer.filters = []
      })  
      this.InfoContainer.on("pointerdown",()=>{
        this.InfoContainer.scale.set(0.95); 
      })
      this.InfoContainer.on("pointerup",()=>{
        this.InfoContainer.scale.set(1); 
      })    
      this.InfoContainer.on("pointerupoutside",()=>{
        this.InfoContainer.scale.set(1); 
      })  
    this.addChild(this.InfoContainer);
  }
}
